import Vue from 'vue';

/**
 * 
 *  Estaría buenisimo pasar esto a TypeScript
 * 
 */
const utils = {
    /**
     * Registra todos los inputs 
     * 
     * @param {HTMLInputElement[]} priceInputs 
     */
    registerPriceInput: (priceInputs) => {
        priceInputs.forEach(priceInput => {
            priceInput.onkeydown = (event) => {
          
                let numberWithDecimalsRegex = /(\,[0-9]{2})$/;
                let twoDecimalsAfterComma = priceInput.value.search(numberWithDecimalsRegex);
                let eventKeyMatches = event.key.match(/(\d|[.,])/gi);
                let ignoredKeys = /(^Backspace$)|(^Tab$)/gi;
                let eventKeyMatchesIgnoredKeys = event.key.match(ignoredKeys);
                
                let selectionStart = priceInput.selectionStart;
                let selectionEnd = priceInput.selectionEnd;
    
                /***
                 * Reglas que previenen el input:
                 *  Si la tecla matchea el patron o ya hay 2 decimales (y el rango de seleccion es mayor o igual a 1)
                 *  Si la tecla no es un Backspace o un Tab
                 */
                    
                if(!eventKeyMatches){   // Si no matcheamos ninguna tecla
                    if(!eventKeyMatchesIgnoredKeys){  // Y tampoco matcheamos las ignoradas
                        event.preventDefault(); 
                    }      
                } else {
                    if (event.key.match(/[,.]/g) && priceInput.value.search(/[,]/g) != -1){ // Solo permitimos una sola , o .
                        event.preventDefault();
                    } else if (twoDecimalsAfterComma != -1 && selectionStart - selectionEnd == 0 && !eventKeyMatchesIgnoredKeys){ // Solo permitimos
                        event.preventDefault();
                    }
                }
                /*
                if(!eventKeyMatches || twoDecimalsAfterComma != -1){  // Si la tecla no matchea el patron, no hacemos nada
                    !event.key.match(ignoredKeys) ?  event.preventDefault() : ''; 
                } 
                */
    
            }
            priceInput.onkeyup = (event) => {
    
                // Reemplazamos . por , 
                let newVal = priceInput.value.replace(/[.]/g, ",")
                priceInput.value = newVal;
            }
            priceInput.onblur = (event) => {
                let newVal = '';
                let commaIndex = priceInput.value.indexOf(',');
                let endsWithComma = priceInput.value.endsWith(',');
                
                if (commaIndex === -1){ 
                    newVal = ',00';
                } else if (endsWithComma){ 
                    newVal = '00';
                } else if (!endsWithComma && commaIndex !== -1){
                    let arr = priceInput.value.split(',');
                    if (arr[1].length === 1){
                        arr[1] = arr[1] + 0;
                        let str = arr.toString(); 
                       
                        priceInput.value = str; 
                    }
                } 
    
                priceInput.value = priceInput.value.length ? priceInput.value + newVal : '0,00';
    
            }
        })
    },
    /**
     * @param {string} price El precio a ser formateado a flotante
     * @returns {number|null}  El numero apto para ser procesado por el backend o null
     */
    getFormattedPrice: (price) => {
        let formattedPrice = parseFloat(price.replace(/,/g, '.'));
        if (isNaN(formattedPrice)) {
            return null;
        } else {
            return formattedPrice;
        }
    },
    /**
     * 
     * @param {string} value 
     * @return {string}
     */
    completeWithZeros(value){

        // 
        let newVal = '';
        // donde esta la coma
        let commaIndex = value.indexOf(',');
        // termina con coma?
        let endsWithComma = value.endsWith(',');
        if (commaIndex === -1){ // no hay coma 
            newVal = ',00';
        } else if (endsWithComma){ // termina con coma
            newVal = '00';
        } else if (!endsWithComma && commaIndex !== -1){ // no termina con coma pero tiene coma
            let arr = value.split(',');
            // Si hay un solo nro despues de la coma
            if (arr[1].length === 1){
                // coerción de tipos ftw
                arr[1] = arr[1] + 0;
                let str = arr.toString(); 
                value = str; 
            }
        }       
        value = value.length ? value + newVal : '0,00';
        return value;
    }
}

Vue.prototype.$utils = utils;

export default utils;